"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchPagination = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
let isFetching = false;
function useSearchPagination({ hasContent, searchTerm, onSearchTermPaginate, userSearch, }) {
    const targetRef = (0, react_1.useRef)(null);
    const observerRef = (0, react_1.useRef)(null);
    const [isAllLoaded, setIsAllLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(function resetAllLoadedWhenSearchTermChange() {
        setIsAllLoaded(false);
    }, [searchTerm]);
    (0, react_1.useEffect)(function listenScrollObserver() {
        var _a;
        const scrollTarget = (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.scroll-target');
        const createObserver = () => {
            var _a;
            if (isAllLoaded) {
                (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
                return;
            }
            if (observerRef.current)
                return;
            observerRef.current = new IntersectionObserver((entries) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _b;
                const target = entries[0];
                if (target.isIntersecting && !isFetching) {
                    isFetching = true;
                    (_b = observerRef.current) === null || _b === void 0 ? void 0 : _b.disconnect();
                    const response = yield onSearchTermPaginate(searchTerm);
                    isFetching = false;
                    if (response && response.length > 0) {
                        createObserver();
                    }
                    else {
                        setIsAllLoaded(true);
                    }
                }
            }), {
                root: null,
                rootMargin: '0px',
                threshold: 0.1,
            });
            observerRef.current.observe(scrollTarget === null || scrollTarget === void 0 ? void 0 : scrollTarget.lastChild);
        };
        if (!isAllLoaded && scrollTarget && !observerRef.current && hasContent) {
            createObserver();
        }
        return () => {
            var _a;
            (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
            observerRef.current = null;
        };
    }, [
        targetRef,
        onSearchTermPaginate,
        searchTerm,
        isAllLoaded,
        observerRef,
        hasContent,
        userSearch,
    ]);
    return {
        targetRef,
    };
}
exports.useSearchPagination = useSearchPagination;
//# sourceMappingURL=useSearchPagination.js.map